export class QuoteSlider {
  #rootElement;
  #quoteSlider;
  #quoteControls;
  #quotes;
  #nrOfQuotes;
  #activeQuoteIndex = 0;
  #touchStartX = 0;

  constructor(element) {
    this.#rootElement = element;
    this.#quoteSlider = this.#rootElement.querySelector('.quote-slider');
    this.#quoteControls = this.#rootElement.querySelectorAll('.quote-controls__control');
    if (!this.#quoteSlider) return;

    this.#quotes = this.#quoteSlider.querySelectorAll('.quote');
    this.#nrOfQuotes = this.#quotes.length > 0 ? this.#quotes.length : 1;

    const initialActive = this.#rootElement.querySelector('.quote--active');
    if (initialActive) this.#activeQuoteIndex = parseInt(initialActive.dataset.quoteIndex, 10);

    this.#init();
    this.#bindEvents();
  }

  #init() {
    this.#quoteSlider.style.width = this.#nrOfQuotes * 100 + 'vw';
    this.#positionSlider(this.#activeQuoteIndex);
  }

  #positionSlider(newIndex) {
    const quoteIndexString = String(newIndex);

    this.#quoteSlider.style.translate = newIndex * -100 + 'vw 0';

    this.#quotes.forEach(quote => {
      if (quote.dataset.quoteIndex === quoteIndexString) quote.classList.add('quote--active');
      else quote.classList.remove('quote--active');
    });

    this.#quoteControls.forEach(quoteControl => {
      if (quoteControl.dataset.gotoQuoteIndex === quoteIndexString)
        quoteControl.classList.add('quote-controls__control--active');
      else
        quoteControl.classList.remove('quote-controls__control--active');
    });

    this.#activeQuoteIndex = newIndex;
  }

  #handleControlTrigger = event => {
    if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
      // Prevent default action for keydown on interactive elements (like buttons/links)
      if (event.type === 'keydown') event.preventDefault();

      const control = event.currentTarget;
      const gotoQuoteIndex = parseInt(control.dataset.gotoQuoteIndex, 10);
      if (gotoQuoteIndex >= 0 && gotoQuoteIndex < this.#nrOfQuotes) this.#positionSlider(gotoQuoteIndex);
    }
  };

  #handleTouchStart = event => {
    this.#touchStartX = event.touches[0].clientX;
  };

  #handleTouchEnd = event => {
    if (this.#touchStartX === 0) return;

    const touchEndX = event.changedTouches[0].clientX;
    const diffX = this.#touchStartX - touchEndX;
    const threshold = 50;

    this.#touchStartX = 0;

    if (Math.abs(diffX) > threshold) {
      let newIndex = this.#activeQuoteIndex;

      if (diffX > 0) newIndex = Math.min(this.#activeQuoteIndex + 1, this.#nrOfQuotes - 1);
      else newIndex = Math.max(this.#activeQuoteIndex - 1, 0);

      if (newIndex !== this.#activeQuoteIndex) this.#positionSlider(newIndex);
    }
  };

  #bindEvents() {
    this.#quoteControls.forEach(quoteControl => {
      quoteControl.addEventListener('click', this.#handleControlTrigger);
      quoteControl.addEventListener('keydown', this.#handleControlTrigger);
    });
    this.#rootElement.addEventListener('touchstart', this.#handleTouchStart, { passive: true });
    this.#rootElement.addEventListener('touchend', this.#handleTouchEnd, { passive: true });
  }
}
